import { c as _c } from "react/compiler-runtime";
import { useIsVisible } from "@website/hooks/is-visible";
import { Button } from "@website/ui/button";
import { useScrollVisibility } from "@website/widget/search-map/animatedButton/use-scroll-visibility.hook";
import { JSX } from "react";
export const AnimatedButton = t0 => {
  const $ = _c(22);
  const {
    onClick,
    className,
    text,
    expandedText,
    icon,
    isNewPlP
  } = t0;
  const isMobileFixedButtonVisible = useScrollVisibility();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      rootMargin: "-120px 0px 0px 0px",
      threshold: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    reference: desktopButtonReference,
    inView: isDesktopButtonInView
  } = useIsVisible(t1, true);
  const isDesktopFixedButtonVisible = !isDesktopButtonInView;
  const animationClassName = `transition-transform duration-300 ${isMobileFixedButtonVisible ? "pointer-events-auto translate-y-0 opacity-100" : "pointer-events-none translate-y-10 opacity-0"}`;
  let t2;
  if ($[1] !== className || $[2] !== expandedText || $[3] !== icon || $[4] !== isDesktopFixedButtonVisible || $[5] !== isNewPlP || $[6] !== onClick || $[7] !== text) {
    t2 = isNewPlP && <><Button aria-label={text} StartIcon={icon} className="!bg-on-surface-high-emphasis shadow-4 !flex w-[98px] !px-0 !text-white" color="neutral" onClick={onClick} text={text} size="small" variant="round-outline" /><Button aria-label={expandedText ?? text} StartIcon={icon} className={`!bg-on-surface-high-emphasis shadow-4 !fixed left-1/2 z-[12] !flex w-[144px] whitespace-nowrap !px-0 !text-white transition-[transform,opacity] duration-300 ease-out ${isDesktopFixedButtonVisible ? "pointer-events-auto -translate-x-1/2 translate-y-0 opacity-100" : "pointer-events-none -translate-x-1/2 translate-y-10 opacity-0"} ${className ?? ""}`} color="neutral" onClick={onClick} size="large" text={expandedText ?? text} variant="round-outline" /></>;
    $[1] = className;
    $[2] = expandedText;
    $[3] = icon;
    $[4] = isDesktopFixedButtonVisible;
    $[5] = isNewPlP;
    $[6] = onClick;
    $[7] = text;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== desktopButtonReference || $[10] !== t2) {
    t3 = <div className="hidden lg:block" ref={desktopButtonReference}>{t2}</div>;
    $[9] = desktopButtonReference;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const t4 = isNewPlP ? expandedText ?? text : text;
  const t5 = `${isNewPlP ? "!bg-on-surface-high-emphasis w-[144px] !text-white" : "w-[222px] !bg-white"} shadow-4 !fixed z-[12] !flex whitespace-nowrap !px-0 ${isNewPlP ? "right-6" : "left-1/2 -translate-x-1/2"} ${animationClassName} ${className ?? ""}`;
  const t6 = isNewPlP ? "neutral" : "secondary";
  const t7 = isNewPlP ? expandedText ?? text : text;
  let t8;
  if ($[12] !== icon || $[13] !== onClick || $[14] !== t4 || $[15] !== t5 || $[16] !== t6 || $[17] !== t7) {
    t8 = <div className="block lg:hidden"><Button aria-label={t4} StartIcon={icon} className={t5} color={t6} onClick={onClick} size="large" text={t7} variant="round-outline" /></div>;
    $[12] = icon;
    $[13] = onClick;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t3 || $[20] !== t8) {
    t9 = <>{t3}{t8}</>;
    $[19] = t3;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};